[
  {
    "id": "SWW-B6-L101-001",
    "module": "SpellingWW",
    "difficulty": 101,
    "difficultyTier": 1,
    "levelCode": "B6",
    "group": 6,
    "question": "Hij ... een appel. (eten)",
    "options": ["eet", "eten", "at", "gegeten"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tegenwoordige_tijd",
    "subSkill": "pv_hij_zij_het",
    "familyId": "SWW-TT-HIJ-ZIJ-HET-BASIS",
    "conceptId": "present_tense_third_person_basic",
    "variantIndex": 1,
    "explanation": "Onderwerp is 'hij' en het is nu, dus tegenwoordige tijd. De juiste persoonsvorm is: eet.",
    "distractorExplanations": {
      "1": "Dit is het hele werkwoord. In de zin heb je de persoonsvorm nodig: eet.",
      "2": "Dit is verleden tijd. In de zin staat geen aanwijzing dat het gisteren was.",
      "3": "Dit is het voltooid deelwoord. Dat gebruik je met 'heeft' of 'is': 'Hij heeft gegeten'."
    }
  },
  {
    "id": "SWW-B6-L101-002",
    "module": "SpellingWW",
    "difficulty": 101,
    "difficultyTier": 1,
    "levelCode": "B6",
    "group": 6,
    "question": "Ik ... naar buiten. (lopen)",
    "options": ["loop", "loopt", "liep", "gelopen"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tegenwoordige_tijd",
    "subSkill": "pv_ik",
    "familyId": "SWW-TT-IK-VORM-STAM",
    "conceptId": "present_tense_first_person_stem",
    "variantIndex": 1,
    "explanation": "Bij 'ik' in de tegenwoordige tijd gebruik je meestal de stam: ik loop.",
    "distractorExplanations": {
      "1": "Dit is de vorm bij hij/zij/het: loopt. Bij 'ik' komt er meestal geen t achter.",
      "2": "Dit is verleden tijd. In deze zin gaat het om nu.",
      "3": "Dit is het voltooid deelwoord en hoort bij 'heb': 'ik heb gelopen'."
    }
  },
  {
    "id": "SWW-B6-L101-003",
    "module": "SpellingWW",
    "difficulty": 101,
    "difficultyTier": 1,
    "levelCode": "B6",
    "group": 6,
    "question": "Gisteren ... ik mijn fiets. (maken)",
    "options": ["maakte", "maakt", "maken", "gemaakt"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verleden_tijd",
    "subSkill": "vt_context_gisteren",
    "familyId": "SWW-VT-CONTEXT-GISTEREN",
    "conceptId": "past_tense_trigger_word_gisteren",
    "variantIndex": 1,
    "explanation": "Door 'gisteren' weet je dat het verleden tijd is. Van 'maken' is de verleden tijd: maakte.",
    "distractorExplanations": {
      "1": "Dit is tegenwoordige tijd. 'Gisteren' vraagt om verleden tijd.",
      "2": "Dit is het hele werkwoord. In de zin heb je de persoonsvorm nodig: maakte.",
      "3": "Dit is het voltooid deelwoord. Dat gebruik je met 'heb': 'Ik heb gemaakt'."
    }
  },
  {
    "id": "SWW-B6-L101-004",
    "module": "SpellingWW",
    "difficulty": 101,
    "difficultyTier": 1,
    "levelCode": "B6",
    "group": 6,
    "question": "Hij ... de deur dicht. (duwen)",
    "options": ["duwt", "duw", "duwde", "geduwd"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tegenwoordige_tijd",
    "subSkill": "pv_hij_zij_het_stam_plus_t",
    "familyId": "SWW-TT-HIJ-ZIJ-HET-STAM_PLUS_T",
    "conceptId": "present_tense_third_person_add_t",
    "variantIndex": 1,
    "explanation": "Onderwerp is 'hij', dus stam + t. Stam van 'duwen' is 'duw'. Duw + t = duwt.",
    "distractorExplanations": {
      "1": "Dit is de ik-vorm: ik duw. Bij 'hij' hoort duwt.",
      "2": "Dit is verleden tijd. In de zin gaat het om wat hij nu doet.",
      "3": "Dit is het voltooid deelwoord. Dat gebruik je met 'heeft': hij heeft geduwd."
    }
  },
  {
    "id": "SWW-B6-L101-005",
    "module": "SpellingWW",
    "difficulty": 101,
    "difficultyTier": 1,
    "levelCode": "B6",
    "group": 6,
    "question": "De taart is ... (bakken).",
    "options": ["gebakken", "gebakt", "bakten", "bakt"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "voltooid_deelwoord",
    "subSkill": "vd_na_is",
    "familyId": "SWW-VD-NA-HULPWERKWOORD",
    "conceptId": "past_participle_after_auxiliary_is",
    "variantIndex": 1,
    "explanation": "Na 'is' gebruik je een voltooid deelwoord. Van 'bakken' is dat: gebakken.",
    "distractorExplanations": {
      "1": "Dit is niet de juiste vorm. 'Gebakt' gebruik je bijvoorbeeld in 'een gebakte vis' (als bijvoeglijk), maar bij 'is' hoort hier: gebakken.",
      "2": "Dit is verleden tijd meervoud (wij bakten). Dat past niet na 'is'.",
      "3": "Dit is tegenwoordige tijd (hij bakt). Na 'is' hoort een voltooid deelwoord."
    }
  }
]
